(function () {
  var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var delay = reduce ? 0 : 120;
  var openTimer = 0;
  var current = null;

  function desk() {
    return window.matchMedia("(min-width: 750px)").matches;
  }

  function panel(item) {
    return item ? item.querySelector(".cjet-mega") : null;
  }

  function setOpen(item, on) {
    if (!item) return;
    var link = item.querySelector("[data-cjet-mega]");
    var pane = panel(item);
    item.classList.toggle("is-open", on);
    if (link) link.setAttribute("aria-expanded", on ? "true" : "false");
    if (pane) {
      pane.setAttribute("aria-hidden", on ? "false" : "true");
      if (on) placePane(item, pane);
    }
  }

  function placePane(item, pane) {
    item.classList.remove("cjet-nav__item--end");
    item.style.removeProperty("--cjet-mega-left");
    item.style.removeProperty("--cjet-mega-right");
    var pad = 16;
    var ir = item.getBoundingClientRect();
    var pw = pane.offsetWidth || 0;
    if (!pw) return;
    if (ir.left + pw <= window.innerWidth - pad) return;
    if (ir.right - pw >= pad) {
      item.classList.add("cjet-nav__item--end");
      return;
    }
    item.style.setProperty("--cjet-mega-left", pad - ir.left + "px");
  }

  function closeAll(except) {
    document.querySelectorAll(".cjet-nav__item.is-open").forEach(function (item) {
      if (item !== except) setOpen(item, false);
    });
    current = except || null;
  }

  function openItem(item) {
    if (!item || !desk()) return;
    closeAll(item);
    setOpen(item, true);
    current = item;
  }

  document.addEventListener("pointerover", function (e) {
    if (!desk()) return;
    var item = e.target.closest(".cjet-nav__item--parent");
    if (!item || !item.closest("#cjet-nav")) return;
    window.clearTimeout(openTimer);
    openTimer = window.setTimeout(function () {
      openItem(item);
    }, delay);
  });

  document.addEventListener("pointerout", function (e) {
    if (!desk()) return;
    var item = e.target.closest(".cjet-nav__item--parent");
    if (!item || !item.closest("#cjet-nav")) return;
    var next = e.relatedTarget;
    if (next && item.contains(next)) return;
    window.clearTimeout(openTimer);
    setOpen(item, false);
    if (current === item) current = null;
  });

  document.addEventListener("focusin", function (e) {
    var item = e.target.closest(".cjet-nav__item--parent");
    if (item && item.closest("#cjet-nav") && desk()) openItem(item);
  });

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") {
      var open = current;
      closeAll();
      if (open) {
        var back = open.querySelector(".cjet-nav__link");
        if (back) back.focus();
      }
      return;
    }
    if (!desk() || !current) return;
    var items = Array.prototype.slice.call(document.querySelectorAll("#cjet-nav .cjet-nav__item--parent"));
    var i = items.indexOf(current);
    if (e.key === "ArrowRight" && i > -1 && items[i + 1]) {
      e.preventDefault();
      openItem(items[i + 1]);
      var n = items[i + 1].querySelector(".cjet-nav__link");
      if (n) n.focus();
    }
    if (e.key === "ArrowLeft" && i > 0) {
      e.preventDefault();
      openItem(items[i - 1]);
      var p = items[i - 1].querySelector(".cjet-nav__link");
      if (p) p.focus();
    }
    if (e.key === "ArrowDown" && current) {
      var first = current.querySelector(".cjet-mega a");
      if (first) {
        e.preventDefault();
        first.focus();
      }
    }
  });

  document.addEventListener("click", function (e) {
    if (!desk()) return;
    if (!e.target.closest("#cjet-nav")) closeAll();
  });

  function onScroll() {
    document.documentElement.classList.toggle("is-scrolled", window.scrollY > 8);
  }
  onScroll();
  window.addEventListener("scroll", onScroll, { passive: true });

  var lastBarH = -1;
  var lastAnnH = -1;
  var lastShellH = -1;
  var measureRaf = 0;

  function measure() {
    var root = document.documentElement;
    var bar = document.querySelector(".cjet-bar");
    var announce = document.querySelector(".announcement-bar, .cjet-announce");
    var barH = bar ? bar.offsetHeight : 0;
    var annH = announce ? announce.offsetHeight : 0;
    var shellH = annH + barH;
    if (bar && barH !== lastBarH) {
      lastBarH = barH;
      root.style.setProperty("--height-header", barH + "px");
      root.style.setProperty("--header-desktop-sticky-height", barH + "px");
      root.style.setProperty("--sticky-offset", barH + "px");
    }
    if (announce && annH !== lastAnnH) {
      lastAnnH = annH;
      root.style.setProperty("--announce-measured", annH + "px");
      root.style.setProperty("--announcement-height", annH + "px");
    }
    if ((bar || announce) && shellH !== lastShellH) {
      lastShellH = shellH;
      root.style.setProperty("--shell-h", shellH + "px");
    }
  }

  function scheduleMeasure() {
    if (measureRaf) return;
    measureRaf = window.requestAnimationFrame(function () {
      measureRaf = 0;
      measure();
    });
  }

  scheduleMeasure();
  if (typeof ResizeObserver === "function") {
    var ro = new ResizeObserver(scheduleMeasure);
    var bar = document.querySelector(".cjet-bar");
    var announce = document.querySelector(".announcement-bar, .cjet-announce");
    if (bar) ro.observe(bar);
    if (announce) ro.observe(announce);
  } else {
    window.addEventListener("resize", scheduleMeasure);
  }

  function esc(s) {
    return String(s || "").replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }

  function money(v) {
    if (v == null || v === "") return "";
    var n = Number(v);
    if (!isFinite(n)) return String(v);
    if (n >= 100 && Number.isInteger(n)) n = n / 100;
    return "$" + n.toFixed(2);
  }

  function imgOf(p) {
    if (!p) return "";
    if (p.featured_image && (p.featured_image.url || p.featured_image.src)) {
      return p.featured_image.url || p.featured_image.src;
    }
    if (typeof p.image === "string") return p.image;
    if (p.image && p.image.url) return p.image.url;
    return "";
  }

  function bindPredict(form) {
    if (form.getAttribute("data-cjet-predict-on") === "1") return;
    var input = form.querySelector("input[type='search'], input[name='q']");
    var box = form.querySelector("[data-cjet-predict-box]");
    if (!input || !box) return;
    form.setAttribute("data-cjet-predict-on", "1");
    var timer = 0;
    var ctrl = null;
    var items = [];
    var on = -1;
    var lastQ = "";

    function hide() {
      box.hidden = true;
      box.innerHTML = "";
      input.setAttribute("aria-expanded", "false");
      items = [];
      on = -1;
    }

    function mark(i) {
      on = i;
      items.forEach(function (el, idx) {
        el.classList.toggle("is-on", idx === i);
      });
      if (items[i]) items[i].scrollIntoView({ block: "nearest" });
    }

    function draw(data, q) {
      var res = (data && data.resources && data.resources.results) || {};
      var queries = res.queries || [];
      var products = res.products || [];
      var collections = res.collections || [];
      var html = "";
      if (queries.length) {
        html += '<p class="cjet-predict__k">Suggestions</p>';
        queries.forEach(function (row) {
          var href = row.url || (form.action + "?q=" + encodeURIComponent(row.text || q));
          html +=
            '<a class="cjet-predict__item" data-cjet-predict-item href="' +
            esc(href) +
            '"><span class="cjet-predict__t">' +
            (row.styled_text || esc(row.text || "")) +
            "</span></a>";
        });
      }
      if (products.length) {
        html += '<p class="cjet-predict__k">Products</p>';
        products.forEach(function (p) {
          var src = imgOf(p);
          var price = money(p.price);
          html +=
            '<a class="cjet-predict__item cjet-predict__item--p" data-cjet-predict-item href="' +
            esc(p.url) +
            '">';
          if (src) {
            html +=
              '<img class="cjet-predict__img" src="' +
              esc(src) +
              '" alt="" width="48" height="48" loading="lazy">';
          }
          html +=
            '<span class="cjet-predict__copy"><span class="cjet-predict__t">' +
            esc(p.title) +
            "</span>";
          if (p.vendor || price) {
            html +=
              '<span class="cjet-predict__m">' +
              esc([p.vendor, price].filter(Boolean).join(" · ")) +
              "</span>";
          }
          html += "</span></a>";
        });
      }
      if (collections.length) {
        html += '<p class="cjet-predict__k">Collections</p>';
        collections.forEach(function (c) {
          html +=
            '<a class="cjet-predict__item" data-cjet-predict-item href="' +
            esc(c.url) +
            '"><span class="cjet-predict__t">' +
            esc(c.title) +
            "</span></a>";
        });
      }
      var all = form.action + (form.action.indexOf("?") >= 0 ? "&" : "?") + "q=" + encodeURIComponent(q);
      if (html) {
        html +=
          '<a class="cjet-predict__more" data-cjet-predict-item href="' +
          esc(all) +
          '">View all results</a>';
      } else {
        html =
          '<a class="cjet-predict__more" data-cjet-predict-item href="' +
          esc(all) +
          '">Search all products for “' +
          esc(q) +
          "”</a>";
      }
      box.innerHTML = html;
      box.hidden = false;
      input.setAttribute("aria-expanded", "true");
      items = Array.prototype.slice.call(box.querySelectorAll("[data-cjet-predict-item]"));
      on = -1;
    }

    function ask(q) {
      if (ctrl) ctrl.abort();
      ctrl = new AbortController();
      var url =
        "/search/suggest.json?q=" +
        encodeURIComponent(q) +
        "&resources[type]=query,product,collection&resources[limit]=6&resources[options][unavailable_products]=hide";
      fetch(url, { signal: ctrl.signal, headers: { Accept: "application/json" } })
        .then(function (r) {
          return r.json();
        })
        .then(function (data) {
          if (input.value.trim() !== q) return;
          draw(data, q);
        })
        .catch(function () {});
    }

    input.addEventListener("input", function () {
      var q = input.value.trim();
      window.clearTimeout(timer);
      if (q.length < 2) {
        hide();
        lastQ = "";
        return;
      }
      if (q === lastQ) return;
      lastQ = q;
      timer = window.setTimeout(function () {
        ask(q);
      }, 160);
    });

    input.addEventListener("focus", function () {
      if (box.innerHTML && input.value.trim().length >= 2) {
        box.hidden = false;
        input.setAttribute("aria-expanded", "true");
      }
    });

    input.addEventListener("keydown", function (e) {
      if (e.key === "Escape") {
        hide();
        return;
      }
      if (box.hidden || !items.length) return;
      if (e.key === "ArrowDown") {
        e.preventDefault();
        mark(on < items.length - 1 ? on + 1 : 0);
      } else if (e.key === "ArrowUp") {
        e.preventDefault();
        mark(on > 0 ? on - 1 : items.length - 1);
      } else if (e.key === "Enter" && on > -1 && items[on]) {
        e.preventDefault();
        window.location.href = items[on].href;
      }
    });

    document.addEventListener("click", function (e) {
      if (!form.contains(e.target)) hide();
    });
  }

  document.querySelectorAll("[data-cjet-predict]").forEach(bindPredict);
})();

(function () {
  function threshold() {
    var el = document.querySelector("[data-cjet-ship-th]");
    var n = el ? parseFloat(el.getAttribute("data-cjet-ship-th")) : 50;
    return n > 0 ? n : 50;
  }

  function money(cents) {
    var n = Math.max(0, Number(cents) || 0) / 100;
    return "$" + n.toFixed(2);
  }

  function paint(total) {
    total = parseInt(total, 10) || 0;
    var rate = 1;
    if (window.Shopify && Shopify.currency && Shopify.currency.rate) {
      rate = parseFloat(Shopify.currency.rate) || 1;
    }
    var need = Math.round(threshold() * rate * 100);
    var left = Math.max(0, need - total);
    var ok = total > 0 && total >= need;
    var pct = need ? Math.min(100, Math.round((total / need) * 100)) : 0;
    var leftMoney = money(left);
    document.querySelectorAll("[data-cjet-ship]").forEach(function (node) {
      var go = node.querySelector("[data-cjet-ship-go]");
      var done = node.querySelector("[data-cjet-ship-done]");
      var amt = node.querySelector("[data-cjet-ship-amt]");
      if (amt) amt.textContent = leftMoney;
      if (go) go.hidden = ok;
      if (done) done.hidden = !ok;
      node.setAttribute("data-cjet-ship-ok", ok ? "1" : "0");
    });
    document.querySelectorAll("[data-free-shipping-bar]").forEach(function (node) {
      var msg = node.querySelector(".free-shipping-bar__message");
      var pending = node.getAttribute("data-free-shipping-pending-message") || "Only {{ remaining_amount }} away from free shipping!";
      var success = node.getAttribute("data-free-shipping-success-message") || "Your order qualifies for free shipping!";
      if (msg) {
        msg.textContent = ok ? success : pending.replace("{{ remaining_amount }}", leftMoney);
      }
      node.dataset.isOverThreshold = ok ? "true" : "false";
      node.dataset.isLoaded = "true";
      var bar = node.querySelector(".free-shipping-bar__bar");
      if (bar) bar.style.setProperty("--progress-width", pct + "%");
    });
  }

  function pull() {
    fetch("/cart.js", { credentials: "same-origin" })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        paint(cart.total_price);
      })
      .catch(function () {});
  }

  var nativeFetch = window.fetch;
  if (typeof nativeFetch === "function") {
    window.fetch = function () {
      var req = arguments[0];
      var url = "";
      if (typeof req === "string") url = req;
      else if (req && req.url) url = req.url;
      return nativeFetch.apply(this, arguments).then(function (res) {
        if (/\/cart\/(add|change|update|clear)/.test(String(url))) {
          window.setTimeout(pull, 60);
        }
        return res;
      });
    };
  }

  document.addEventListener("apps:product-added-to-cart", pull);
  document.addEventListener("click", function (e) {
    if (e.target.closest("[data-add-to-cart], [data-remove-item], [name='add'], .quantity-input")) {
      window.setTimeout(pull, 420);
    }
  });

  var bar = document.querySelector("[data-free-shipping-bar]");
  if (bar && bar.dataset.cartTotal) paint(bar.dataset.cartTotal);
})();
/* Müşteri deneyimi H7 (3 Kas 2026, Musteri-Deneyimi-Tum-Siteler): sohbet düğmesi kaydırırken saklanır; durunca korunan öğeyi örtüyorsa saklı kalır. DK dk-tema-kusur deseni. */
(function () {
  var html = document.documentElement, zaman = 0, zaman2 = 0;
  var korunan = '#omnisend-forms-wrapper form, .cjet-foot__news-form input, .cjet-pdp__trust, .product-form__submit, .shopify-payment-button__button';
  html.classList.add('mx-yuzen-izle');
  function ortuyor(e) {
    // Saklama yalnız görünürlükle yapılır; kutu yerinde kalır, ölçüm saklıyken de doğru.
    var a = e.getBoundingClientRect();
    if (!a.width) return false;
    return [].some.call(document.querySelectorAll(korunan), function (k) {
      // Kapalı <details> içeriği görünmez ama kutusu ölçülür: örtme sayılmaz.
      if (k.closest('details:not([open])')) return false;
      var r = k.getBoundingClientRect();
      // Kapanırken yerinde kalan kap (visibility, opacity ya da sıfır yükseklik) örtme sayılmaz.
      var st = getComputedStyle(k);
      if (!r.height || st.visibility === 'hidden' || st.opacity === '0') return false;
      // Ata kap opacity ile kapanırsa çocuğun kendi değeri 1 kalır; destekleyen tarayıcıda zincir okunur.
      if (k.checkVisibility && !k.checkVisibility({ opacityProperty: true, visibilityProperty: true })) return false;
      return r.width && r.left < a.right && r.right > a.left && r.top < a.bottom && r.bottom > a.top;
    });
  }
  function karar(kaydiriyor) {
    var e = document.getElementById('dkc-btn'), panel = document.getElementById('dkc-panel');
    // Klavye odağı düğmedeyken saklanmaz: visibility hidden odağı düşürür.
    var sakla = !!e && !(panel && panel.classList.contains('open')) && !e.contains(document.activeElement) && (kaydiriyor || ortuyor(e));
    html.classList.toggle('mx-cekik-sohbet', sakla);
  }
  window.addEventListener('scroll', function () {
    karar(true);
    clearTimeout(zaman); clearTimeout(zaman2);
    zaman = setTimeout(function () { karar(false); }, 150);
    // Kaydırma bitince yüklenen görseller yerleşimi kaydırabilir: karar bir kez daha verilir.
    zaman2 = setTimeout(function () { karar(false); }, 750);
  }, { passive: true });
  window.addEventListener('resize', function () { karar(false); });
  // Klavyeyle düğmeye gelen kullanıcı için saklama kalkar; saklama yalnız görünümdedir, sekme sırasından çıkarmaz.
  document.addEventListener('focusin', function () { karar(false); });
  document.addEventListener('toggle', function (ev) { if (ev.target && ev.target.tagName === 'DETAILS') karar(false); }, true);
  function sonra() { karar(false); setTimeout(function () { karar(false); }, 400); setTimeout(function () { karar(false); }, 2500); }
  // Sohbet düğmesi geç yüklenir; açılır form kaydırma olmadan gelir ve gider: ikisinde de karar yinelenir.
  var dugmeVar = false;
  new MutationObserver(function (kayitlar) {
    if (!dugmeVar && document.getElementById('dkc-btn')) { dugmeVar = true; sonra(); return; }
    if (kayitlar.some(function (k) { return k.target.closest && k.target.closest('#omnisend-forms-wrapper'); })) sonra();
  }).observe(document.body, { childList: true, subtree: true });
  window.addEventListener('load', sonra);
  // Form kapanırken öğesi DOM'dan kalkmayabilir: tık sonrası karar yinelenir.
  function sonraTik() { setTimeout(function () { karar(false); }, 400); }
  // Yakalama evresi: kapatma düğmesi stopPropagation yapsa da karar yinelenir; ESC ile kapanış da aynı yolda.
  document.addEventListener('click', sonraTik, true);
  document.addEventListener('keyup', function (ev) { if (ev.key === 'Escape') sonraTik(); });
  karar(false);
})();
